/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/05/22
 */

import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';
import StateDisplay, { StateDisplayProps } from '@/components/StateDisplay/StateDisplay';
import { WorkplanNotLoadedAlert } from '@/components/WorkplanNotLoadedAlert/WorkplanNotLoadedAlert';
import { Workplan, WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';
import React from 'react';
import useWorkplanVersion from '@/components/contexts/VersionContext/useWorkplanVersion';

interface WorkplanVersionStateDisplayProps
    extends Pick<StateDisplayProps<[Workplan, WorkplanVersion]>, 'render' | 'renderLoading' | 'fullscreenLoading'> {
    renderError?: StateDisplayProps<[Workplan, WorkplanVersion]>['errorRender'];
}

const WorkplanVersionStateDisplay = ({
    render,
    renderLoading,
    renderError,
    fullscreenLoading,
}: WorkplanVersionStateDisplayProps) => {
    const { loading, workplan, error } = useWorkplan();
    const { workplanVersion, loading: versionLoading, error: versionError } = useWorkplanVersion();
    return (
        <StateDisplay
            fullscreenLoading={fullscreenLoading}
            loading={loading || versionLoading}
            error={!!error || versionError}
            errorRender={renderError ?? (() => <WorkplanNotLoadedAlert />)}
            data={workplan && workplanVersion ? [workplan, workplanVersion] : undefined}
            render={render}
            renderLoading={renderLoading}
        />
    );
};

export default WorkplanVersionStateDisplay;
